import { isEmptyScObj } from "../../utils/siteUtils";
import React, { useState } from "react";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import { PrimaryButton } from "../../elements";
import SelectVerificationMethodModal from "../../react-components/select-verification-method-modal";
import ResetPassword from "../../components/ResetPassword";
import { selectUserState } from "../../selectors/application";
import { connect } from "react-redux";
import { LOGOUT, setUserInfoAction } from "../../redux/actions";
import InputPhoneNumber from "../../elements/InputPhoneNumber";
import useChangePhoneNumberModal from "../../hooks/useChangePhoneNumberModal";

function AccountPhoneNumberSetting(props) {
  if (isEmptyScObj(props)) {
    return null;
  } else {
    return <AccountPhoneNumberSettingMain {...props} />;
  }
}
function AccountPhoneNumberSettingMain(props) {
  const {
    verifyEmailForm,
    selectVerificationMethodModal,
    fields: { headingTypephoneNumber, headingBodyPhoneNumber, bodyPhoneNumber, modalChangePhoneNumber, phoneMissingMessage, phoneWarningMessage }
  } = props;

  const { phoneProps, ctaChangePhoneNumber, changePhoneNumberModalProps, onSubmitPhoneNumberChange, resetPasswordProps, serverError, updatedMessage, verificationModalProps } = useChangePhoneNumberModal({
    fields: modalChangePhoneNumber?.fields,
    verifyEmailForm,
    selectVerificationMethodModal
  });
  return (
    <div className="section">
      <Heading type={headingTypephoneNumber} typographyClass="type-h3" html={headingBodyPhoneNumber} />
      <BodyText html={bodyPhoneNumber.value} className="form-section-builder-section-body" />
      <InputPhoneNumber {...phoneProps} />

      {updatedMessage && <BodyText className="update-message" html={updatedMessage} />}
      {serverError && <div className="failed-message">{serverError}</div>}
      {ctaChangePhoneNumber && <PrimaryButton {...ctaChangePhoneNumber} />}
      {ctaChangePhoneNumber && <SelectVerificationMethodModal type="phoneChange" {...verificationModalProps} />}
      {ctaChangePhoneNumber && <ResetPassword {...resetPasswordProps} />}
    </div>
  );
}

const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  logout: () => dispatch({ type: LOGOUT }),
  setUserInfo: data => dispatch(setUserInfoAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountPhoneNumberSetting);
